import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const DateOut = () => {
  const date_out = useInputStore(state => state.date_out)
  const date_in = useInputStore(state => state.date_in)
  const setValue = useInputStore((state) => state.set_value)

  const handleChange = (event) => {
    setValue({ 'date_out': event.target.value})
  }

  // validation
  const isValidDate = useCallback(() => {
    const date = new Date(date_out)
    const date_in_date = new Date(date_in)

    // is it a valid date && after date in
    return !isNaN(date) && date > date_in_date
  }, [date_out, date_in])

  useStepValidator(INPUT_STEP_NAMES.housing, 'date_out', () => isValidDate(date_out, date_in))
  
  return (
    <Tooltip title='Day cows were brought out or expected to be brought out'>
      <TextField
        size='small'
        label='Date Out'
        type='date'
        InputLabelProps={{
          shrink: true,
        }}
        value={date_out}
        onChange={handleChange}
        error={!isValidDate()}
        helperText={!isValidDate() ? 'Please select a valid date after Date In' : ''}
      />
    </Tooltip>
  )
}
